export const PACKAGES = [
  { id: "daily", label: "Daily", short: "Day" },
  { id: "weekend", label: "Weekend", short: "Weekend", note: "Friday morning to Monday morning" },
  { id: "week", label: "Week", short: "Week" },
  { id: "month", label: "Month", short: "Month" },
];

export const MILE_RATE = 2.2;

export const LOGISTICS_OPTIONS = [
  { id: "peterborough", label: "Collection from Peterborough", desc: "Collect and return the vehicle at our Peterborough base." },
  { id: "delivery", label: "Delivery Only", desc: "We deliver the vehicle to your chosen location." },
  { id: "collection", label: "Collection Only", desc: "We collect the vehicle from your location at the end of hire." },
  { id: "both", label: "Delivery + Collection", desc: "We deliver at the start and collect at the end. Two separate journeys, each charged per mile." },
];

export const VEHICLES = [
  { id: "audi-rs4", name: "Audi RS4", prices: { daily: 400, weekend: 1200, week: 1700, month: 5100 }, deposit: 1000 },
  { id: "audi-rs3-8y", name: "Audi RS3 8Y", prices: { daily: 350, weekend: 1000, week: 1500, month: 4500 }, deposit: 1000 },
  { id: "audi-rs3-daza", name: "Audi RS3 Daza", prices: { daily: 270, weekend: 800, week: 1150, month: 3500 }, deposit: 750 },
  { id: "mercedes-c43", name: "Mercedes C43", prices: { daily: 300, weekend: 900, week: 1300, month: 4000 }, deposit: 750 },
  { id: "vw-golf-r", name: "VW Golf R", prices: { daily: 220, weekend: 650, week: 1000, month: 3000 }, deposit: 500 },
  { id: "vw-mark-8-gtd", name: "VW Mark 8 GTD", prices: { daily: 200, weekend: 600, week: 850, month: 2500 }, deposit: 500 },
  { id: "mercedes-a35", name: "Mercedes A35", prices: { daily: 250, weekend: 750, week: 1250, month: 3500 }, deposit: 750 },
  { id: "bmw-m340d", name: "BMW M340D", prices: { daily: 250, weekend: 750, week: 1250, month: 3500 }, deposit: 750 },
  { id: "bmw-m135i", name: "BMW M135i", prices: { daily: 240, weekend: 700, week: 1200, month: 3300 }, deposit: 750 },
  { id: "c-class-estate", name: "C Class Estate", prices: { daily: 170, weekend: 520, week: 700, month: 2200 }, deposit: 500 },
  { id: "audi-rsq8", name: "Audi RSQ8", enquiryOnly: true, photos: ["/assets/vehicles/rsq8.jpg"] },
  { id: "range-rover-sport", name: "Range Rover Sport", enquiryOnly: true, photos: ["/assets/vehicles/rr-sport.jpg"] },
  { id: "range-rover-sport-svr", name: "Range Rover Sport SVR", enquiryOnly: true, photos: ["/assets/vehicles/rr-svr.jpg"] },
  { id: "lamborghini-urus", name: "Lamborghini Urus", enquiryOnly: true, photos: ["/assets/vehicles/urus-front.jpg", "/assets/vehicles/urus-rear.jpg"] },
];

export const CONTACT_NUMBER = "+44 7457 418474";
export const WHATSAPP_URL = "https://wa.me/447457418474";
export const WHATSAPP_DISPLAY = "+44 7457 418474";
export const waLink = (message) =>
  `https://wa.me/447457418474${message ? `?text=${encodeURIComponent(message)}` : ""}`;
